export const MINIMUM_AGE_NON_UTMA_ACCT = 18;
export const MAXIMUM_AGE_FOR_UTMA_ACCT = 21;
